import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import {
  getAPIErrorMessage,
  getSegmentApiRequestObject
} from '@nw/shared/utils';

import { GetBackendSegmentEventRequestType } from '../../../services/PaymentServices/APIService/types';

import usePaymentServices from '../usePaymentServices';

interface UseBackendSegmentAPIInterface {
  sendBackendSegmentApi: UseMutateAsyncFunction<
    {},
    unknown,
    { event: string; eventData: string; orderId: string },
    unknown
  >;
  error: string;
  status: MutationStatus;
}

const useBackendSegmentApi = (): UseBackendSegmentAPIInterface => {
  const { paymentServices } = usePaymentServices();

  const callBackendSegment = ({ event, eventData, orderId }) => {
    const request: GetBackendSegmentEventRequestType =
      getSegmentApiRequestObject(event, eventData, orderId);

    return paymentServices.segmentEvent(request);
  };

  const { mutateAsync, error, status } = useMutation(callBackendSegment, {
    mutationKey: ['sendBackendSegmentApi']
  });

  const sendBackendSegmentApi = mutateAsync;

  return {
    sendBackendSegmentApi,
    error: error ? getAPIErrorMessage(error) : '',
    status
  };
};

export { useBackendSegmentApi };
